import _ from 'lodash'
import Vue from 'vue'
import axios from 'axios'
import * as types from '../../types'
import swear from '../../utils/swear'
import laroute from '../../../vendor/laroute'

const state = {
    item: null
}

const getters = {
    [types.users.modules.current.getters.item]: state => state.item
}

const actions = {
    [types.users.modules.current.actions.find] ({ commit }, { params }) {
        return swear(() => {
            return axios
                .get(laroute.route('api.users.show', params))
                .then(({ data: item }) => {
                    commit(types.users.modules.current.mutations.found, { item })
                })
        })
    },
    [types.users.modules.current.actions.merge] ({ commit, dispatch }, { item }) {
        return new Promise((resolve, reject) => {
            try {
                commit(types.users.modules.current.mutations.merged, { item })
                resolve()
            } catch (error) {
                dispatch(types.errors.actions.axios, error)
                reject(error)
            }
        })
    }

}

const mutations = {
    [types.users.modules.current.mutations.found] (state, payload) {
        Vue.set(state, 'item', payload.item)

        axios.defaults.headers.common.Authorization = 'Bearer ' + payload.item.api_token
    },
    [types.users.modules.current.mutations.merged] (state, payload) {
        _.merge(state.item, payload.item)
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
